import React, { Component } from "react";
import * as pr from "../../common/PrimeComponents";
import * as Log from "../../common/Feedback/Log";
import * as format from "../../common/FormatFunctions";

import {
  ViewState,
  ValidateState,
  CrudlStatus
} from "../../common/config/AppConstants";

import { SBLSelector } from "../Sites/SBLSelector";

export class BPMAddressSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: null,
      errors: []
    };

    this.logger = Log;
  }

  render() {
    return <React.Fragment>)}</React.Fragment>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/BPMAddressSelector.js